<router-outlet></router-outlet>
<fz-footer [theme]="colorScheme"></fz-footer>
